/******/ (() => { // webpackBootstrap
var __webpack_exports__ = {};
window.PXUTheme.jsSidebar = {
  init() {
    const facetedFilterForm = document.querySelector('[data-faceted-filter-form]');

    if (facetedFilterForm) {
      facetedFilterForm.addEventListener('change', e => {
        if (e.target.type === 'number') return;
        const formData = new FormData(facetedFilterForm);
        const facetedFilterSearchParams = new URLSearchParams(formData);
        const existingSearchParams = new URLSearchParams(window.location.search);
        const newSearchParams = new URLSearchParams();

        Array.from(facetedFilterSearchParams.entries(), ([key, value]) => {
          newSearchParams.append(key, value);
          return null;
        });

        Array.from(existingSearchParams.entries(), ([key, value]) => {
          if (!key.includes('filter.p') && !key.includes('filter.v')) {
            newSearchParams.append(key, value);
          }
          return null;
        });

        window.location.search = newSearchParams.toString();
      });
    }

    // Close all sidebar blocks initially
    $('.sidebar-block__content').hide();
    $('[data-sidebar-block__toggle]').attr('data-sidebar-block__toggle', 'closed');
    $('.sidebar__block').removeClass('is-active').attr('aria-expanded', false);

    // Handle clicks on the sidebar block headers
    // $('[data-has-toggle-option]').on('click', (e) => {
    //   e.preventDefault();
    //   e.stopPropagation();

    //   const $clickedBlock = $(e.currentTarget).closest('.sidebar__block');
    //   const $toggleBtn = $clickedBlock.find('[data-sidebar-block__toggle]');
    //   const isOpen = $clickedBlock.hasClass('is-active');

    //   // Close all blocks first
    //   $('.sidebar__block').each((_, block) => {
    //     const $block = $(block);
    //     if ($block[0] !== $clickedBlock[0]) {  // Don't close the clicked block yet
    //       $block.removeClass('is-active')
    //             .attr('aria-expanded', false)
    //             .find('[data-sidebar-block__toggle]')
    //             .attr('data-sidebar-block__toggle', 'closed');
          
    //       $block.find('.sidebar-block__content').slideUp(300);
    //     }
    //   });

    //   // Toggle the clicked block
    //   if (isOpen) {
    //     this.closeSidebarBlock($toggleBtn);
    //     $('.collection__main').removeClass('filter-open');
    //   } else {
    //     this.openSidebarBlock($toggleBtn);
    //     $('.collection__main').addClass('filter-open');
    //   }
    // });

    $('[data-has-toggle-option]').on('click', function(e) {
    e.preventDefault();
  
    // Find the content to toggle
    const $clickedToggle = $(this);
    const $dropDown = $clickedToggle.closest('.sidebar__block').find('.sidebar-block__content');
    
    // Close other dropdowns
    $clickedToggle.closest('.faceted-filter-form')
      .find('.sidebar-block__content')
      .not($dropDown)
      .slideUp();
  
    // Toggle open class and filter-open class
    if ($clickedToggle.hasClass('open')) {
      $clickedToggle.removeClass('open');
      $('.collection__main').removeClass('filter-open');
    } else {
      // Remove open class from other toggles
      $clickedToggle.closest('.faceted-filter-form')
        .find('[data-has-toggle-option].open')
        .removeClass('open');
      
      // Add open class to clicked toggle
      $clickedToggle.addClass('open');
      $('.collection__main').addClass('filter-open');
    }
  
    // Toggle the dropdown
    $dropDown.stop(false, true).slideToggle();
  });

    // Prevent content clicks from closing
    $('.sidebar-block__content').on('click', (e) => {
      e.stopPropagation();
    });

    if ($('[data-product-sidebar]').length) {
      $('.section--has-sidebar-option').addClass('has-sidebar-enabled');
      $('.section--has-sidebar-option').removeClass('has-sidebar-disabled');
    } else {
      $('.section--has-sidebar-option').removeClass('has-sidebar-enabled');
      $('.section--has-sidebar-option').addClass('has-sidebar-disabled');
    }
  },
  openSidebarBlock($toggleBtn) {
    const $parentBlock = $toggleBtn.closest('.sidebar__block');

    // Close all other blocks first
    $('.sidebar__block').not($parentBlock).each((_, block) => {
      const $block = $(block);
      $block.removeClass('is-active')
            .attr('aria-expanded', false)
            .find('[data-sidebar-block__toggle]')
            .attr('data-sidebar-block__toggle', 'closed');
      
      $block.find('.sidebar-block__content').slideUp(300);
    });

    // Open the selected block
    $toggleBtn.attr('data-sidebar-block__toggle', 'open');
    $parentBlock.addClass('is-active');
    $parentBlock.attr('aria-expanded', true);
    $parentBlock.find('.sidebar-block__content').slideDown(300);
  },
  closeSidebarBlock($toggleBtn) {
    const $parentBlock = $toggleBtn.closest('.sidebar__block');

    $toggleBtn.attr('data-sidebar-block__toggle', 'closed');
    $parentBlock.removeClass('is-active');
    $parentBlock.attr('aria-expanded', false);
    $parentBlock.find('.sidebar-block__content').slideUp(300);
  },
  unload() {
    $('[data-has-toggle-option]').off('click');
    $('.sidebar-block__content').off('click');
  },
};

/******/ })();